"use client";
import { useCallback, useEffect, useState } from "react";
import {
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import LayoutPage from "./pages/LayoutPage";
import { RoutesEnum } from "./utils/RoutesUtil";
import { ToastContainer } from "react-toastify";
import ProspectingTrackerDetailsPage from "./pages/ProspectingTrackerDetailsPage";
import TrackerPage from "./pages/TrackerPage";
import { TrackersEnum } from "./models/TrackerModel";
import Service from "./services";
import "react-toastify/dist/ReactToastify.css";
import { catchError } from "./utils/Utils";
import { BankUserContext } from "./bankUserContext";
import { IOrgProductModel } from "./models/SharedModel";
import LandingPage from "./pages/LandingPage";
import ApiCallback from "./components/Authentication/ApiCallBack";
import ProtectedRoute from "./components/Authentication/ProtectedRoute";
import React from "react";
import { AxiosError, AxiosResponse } from "axios";
import MessageCenterFC from "./components/MessageCenter/MessageCenterFC";
import CaseTrackerPage from "./pages/CaseTrackerPage";
import QuestionnariePage from "./pages/QuestionaryPage";
import Settings from "./components/Settings/Settings";
import Forgotusername from "./components/Forgotpassword/Forgotusername";
import Forgotpassword from "./components/Forgotpassword/Forgotpassword";
import DocuSignPage from "./pages/DocuSignPage";
import Resetpassword from "./components/Forgotpassword/Resetpassword";
import CaseDetailsPage from "./components/CaseManagement/CaseDetails/CaseDetailsPage";
import FallBackUI from "./ErrorHandling/FallbackHandler";
import { ErrorBoundary } from "react-error-boundary";
import AccessDenied from "./ErrorHandling/AccessDenied";
import { RoleAuthorizationCC } from "./components/Authentication/RoleAuthorizationClassComponent";
import AdminSettings from "./pages/AdminSettings";
import SessionTimeout from "./SessionTimeout";
import SessionTimeOutPage from "./pages/SessionTimeOutPage";
import ClientPortalDashboard from "./pages/ClientportalDashboardMaster";
import ClientPortalCategoriesDetails from "./pages/ClientportalCategoriesDetailspage";
import MangementReviewDashboard from "./pages/MangementReviewDashboard";
import { Helmet } from "react-helmet";
import ClientPortalQuestionarie from "./pages/ClientPortalQuestionarie";
import ReviewSummaryReportPage from "./components/ClientPortal/Questionarie/ReviewSummaryReportPage";
import DashboardPage from "./components/AdminSettings/DashboardKPIS/DashboardPage";
import ViewSchedule from "./components/procpectingDetailPge/ScheduleA";
import RiskSettingsDashboard from "./pages/RiskSettingsDashboard";


// interface
interface ColorProps {
  name: string;
  color: string;
  group: string;
}

interface ILogo {
  logo_path: string;
}

interface Menu {
  prospecting: string;
  relationship: string;
  caseTracker: string;
  messageCenter: string;
  applications: string,
  opportunities: string,
  underwriting: string,
  trackers: string;
  settings: string,
  dashboard: string,
  tabName: string
}
// Helper function to convert hex color to RGB
function hexToRgb(hexColor: string): string {
  // remove the # tag
  const hex = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);
  return `${red}, ${green}, ${blue}`;
}

function fallbackRender({ error, resetErrorBoundary }: any) {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre style={{ color: "red" }}>{error.message}</pre>
    </div>
  );
}

function App() {
  const service = new Service();
  const [orgProductsList, setOrgProductsList] = useState<IOrgProductModel[]>(
    []
  );
  const [selectedProduct, setSelectedProduct] =
    useState<IOrgProductModel | null>(null);
  const [bankUserDetails, setBankUserDetails] = useState<any>(null);
  const [bankRolesData, setBankRolesDetails] = useState<any>(null);
  const [compliancepageRefresh, setcompliancepageRefresh] = useState(false);
  const [logosList, setLogosList] = useState<ILogo[]>([]);
  const [menuItems, setMenuItemsArray] = useState<Menu>({ prospecting: "", relationship: "", caseTracker: "", messageCenter: "", applications: "", opportunities: "", underwriting: "", trackers: "", settings: "", dashboard: "", tabName: "" });
  const token: string | undefined | null = localStorage.getItem("token");
  const [clientId, setClientId] = useState(null);
  const [dynamicFavIcon, setDynamicFavIcon] = useState();

  /* Fetch the org ID from URL for forgot Screens */
  const urlSegments = window.location.href.split("/");
  const organizationId = urlSegments[urlSegments.length - 1];

  const getColorsList = (orgId: any) => {
    service
      .getBrandColors(orgId)
      .then((res: any) => {
        setColorsArray(JSON.parse(res?.data[0]?.template_style) || []);
        setMenuItemsArray(JSON.parse(res?.data[0]?.menu_item_data) || []);
      })
      .catch((err) => {
        catchError(err, false);
      });
  };

  const getOrgProductsByOrgId = () => {   
      const payload = {
      roleId: bankRolesData && bankRolesData?.roleId,
      screen: "ProspectDetails",
      sections: "getOrgProductsByOrgId",
      orgId: bankUserDetails?.organization?.orgId,
      isJsonReturnObject: false,
    };   
    service
      .getOrgProductsByOrgId(payload)
      .then((res) => {
        setOrgProductsList(res?.data);
        sessionStorage.setItem("orgProductsList", JSON.stringify(res?.data));
      })
      .catch((err) => catchError(err, true));
  
    
  };

  const getArchiveData = () => {
    const payload = {
      screen: "LandingPage",
      sections: "getArchiveTemplate",
      orgId: bankUserDetails?.organization?.orgId,
      isJsonReturnObject: true
    }
    service
      .getArchiveDataByOrgId(payload)
      .then((res) => {
        sessionStorage.setItem("archiveData", JSON.stringify(res?.data));
      })
      .catch((err) => catchError(err, true));
  }

  useEffect(() => {
    updatedClientDetails(token);
    if (token) getArchiveData()
  }, []);

  const updateClientId = (value: any) => {
    setClientId(value);
  };

  const updateComplainceDashboardPage = (value: boolean) => {
    setcompliancepageRefresh(value);
  };

  useEffect(() => {
    if (bankUserDetails?.organization?.orgId) {     
      getLogosList(bankUserDetails?.organization?.orgId);
      getColorsList(bankUserDetails?.organization?.orgId);
    }
  }, [bankUserDetails?.organization?.orgId]);
 

  useEffect(()=>{
    if(bankRolesData?.roleId){
     getOrgProductsByOrgId();
    }
     },[bankRolesData?.roleId])

  //  let orgId ="a3fe60fe-3f6f-11ee-be56-0242ac120002"

  useEffect(() => {
    // taking orgId from params before login for resetpswd/forgotpswd
    const currentUrl = window.location.href;
    if (
      currentUrl.includes("forgotpassword") ||
      currentUrl.includes("forgotusername") ||
      currentUrl.includes("sessiontimeoutpage")
    ) {
      getLogosList(organizationId);
      getColorsList(organizationId);
    }
  }, []);

  const updatedClientDetails =  useCallback((token: any) => {
    if (token !== null) {
      service
        .getUserDetails()
        .then((response: AxiosResponse) => {
          setBankUserDetails(response.data);         
          service
            .getClaims(token, response.data?.organization.orgId)
            .then((response: AxiosResponse) => {
              if (response.data) {               
                const roleId =(response.data[0]);
                setBankRolesDetails(roleId)
              }
            })
            .catch((error: AxiosError) => {
              catchError(error, false);
            });
        })
        .catch((error: AxiosError) => {
          catchError(error, true);
        });

    }
  }, []);

  
  const setColorAndCssVariable = (
    colorName: string,
    defaultColor: string,
    colorsArray: ColorProps[]
  ) => {
    const colorData = colorsArray.find((color) => color.name === colorName);
    const color = colorData?.color || defaultColor;

    // Set the CSS variable
    document.documentElement.style.setProperty(
      `--${colorName}`,
      hexToRgb(color)
    );

    return color;
  };
  // A function to set CSS variable
  const setCssVariable = (variableName: string, color: string) => {
    document.documentElement.style.setProperty(variableName, color);
  };

  // state to store the dynamic colors
  const [colorsArray, setColorsArray] = useState<ColorProps[]>([]);

  // Set the colors and CSS variables
  const sidebarRgbColor = setColorAndCssVariable(
    "sidebarBackgroundColor",
    "#585858",
    colorsArray
  );
  const sidebarActiveBackgroundColor = setColorAndCssVariable(
    "sidebarActiveBackgroundColor",
    "#585858",
    colorsArray
  );
  const activeSidebarRgbColor = setColorAndCssVariable(
    "sidebarActiveFontColor",
    "#212121",
    colorsArray
  );
  const sidebarFontColor = setColorAndCssVariable(
    "sidebarFontColor",
    "#212121",
    colorsArray
  );
  const headerNavbarRgbColor = setColorAndCssVariable(
    "headerNavBarBackgroundColor",
    "#252525",
    colorsArray
  );
  const progressBarRgbStartColor = setColorAndCssVariable(
    "statusbarBackgroundColor",
    "#252525",
    colorsArray
  );
  const primaryButtonColor = setColorAndCssVariable(
    "buttonBackgroundColor",
    "#252525",
    colorsArray
  );
  const primaryButtonFontColor = setColorAndCssVariable(
    "buttonFontColor",
    "#FFFFFF",
    colorsArray
  );
  const proCardBodyBackgroundColor = setColorAndCssVariable(
    "proCardBodyBackgroundColor",
    "#FFFFFF",
    colorsArray
  );
  const proCardBackgroundColor = setColorAndCssVariable(
    "proCardBackgroundColor",
    "#dfdfdf",
    colorsArray
  );
  const proCardSubTitleFontColor = setColorAndCssVariable(
    "proCardSubTitleFontColor",
    "#3C3C3C",
    colorsArray
  );
  const proCardTitleFontColor = setColorAndCssVariable(
    "proCardTitleFontColor",
    "#252525",
    colorsArray
  );
  const proCardFontColor = setColorAndCssVariable(
    "proCardFontColor",
    "#878787",
    colorsArray
  );
  const loginPrimaryBackgroundColor = setColorAndCssVariable(
    "loginPrimaryBackgroundColor",
    "#252525",
    colorsArray
  );
  const loginSecondaryBackgroundColor = setColorAndCssVariable(
    "loginSecondaryBackgroundColor",
    "#3d3d3d",
    colorsArray
  );
  const listPrimaryBackgroundColor = setColorAndCssVariable(
    "listPrimaryBackgroundColor",
    "#F7F7F7",
    colorsArray
  );
  const listSecondaryBackgroundColor = setColorAndCssVariable(
    "listSecondaryBackgroundColor",
    "#F7F7F7",
    colorsArray
  );
  const listBorderColor = setColorAndCssVariable(
    "listBorderColor",
    "#D4AF37",
    colorsArray
  );
  const listHeaderFontColor = setColorAndCssVariable(
    "listHeaderFontColor",
    "#868686",
    colorsArray
  );
  const listHeaderSortIconFontColor = setColorAndCssVariable(
    "listHeaderSortIconFontColor",
    "#A28014",
    colorsArray
  );
  const listFirstColumnFontColor = setColorAndCssVariable(
    "listFirstColumnFontColor",
    "#000000",
    colorsArray
  );
  const listFontColor = setColorAndCssVariable(
    "listFontColor",
    "#373737",
    colorsArray
  );
  const loginButtonBgColor = setColorAndCssVariable(
    "loginButtonBgColor",
    "#FFFFFF",
    colorsArray
  );
  const loginButtonFontColor = setColorAndCssVariable(
    "loginButtonFontColor",
    "#FFFFFF",
    colorsArray
  );
  const loginFontColor = setColorAndCssVariable(
    "loginFontColor",
    "#FFFFFF",
    colorsArray
  );
  // Use useEffect to apply the styles when state changes
  useEffect(() => {
    // Set the CSS variables using the previously set colors
    setCssVariable("--sidebarBackgroundColor", hexToRgb(sidebarRgbColor));
    setCssVariable("--sidebarFontColor", hexToRgb(sidebarFontColor));
    setCssVariable("--sidebarActiveBackgroundColor", hexToRgb(sidebarRgbColor));
    setCssVariable("--sidebarActiveFontColor", hexToRgb(activeSidebarRgbColor));
    setCssVariable(
      "--headerNavbarBackgroundColor",
      hexToRgb(headerNavbarRgbColor)
    );
    setCssVariable("--progressbar-color-0", hexToRgb(progressBarRgbStartColor));
    setCssVariable("--buttonBackgroundColor", hexToRgb(primaryButtonColor));
    setCssVariable("--buttonFontColor", hexToRgb(primaryButtonFontColor));
    setCssVariable(
      "--proCardBodyBackgroundColor",
      hexToRgb(proCardBodyBackgroundColor)
    );
    setCssVariable(
      "--proCardBackgroundColor",
      hexToRgb(proCardBackgroundColor)
    );
    setCssVariable(
      "--proCardSubTitleFontColor",
      hexToRgb(proCardSubTitleFontColor)
    );
    setCssVariable("--proCardTitleFontColor", hexToRgb(proCardTitleFontColor));
    setCssVariable("--proCardFontColor", hexToRgb(proCardFontColor));
    setCssVariable(
      "--primaryButtonBackgroundColor",
      hexToRgb(primaryButtonColor)
    );

    setCssVariable(
      "--loginPrimaryBackgroundColor",
      hexToRgb(loginPrimaryBackgroundColor)
    );
    setCssVariable(
      "--loginSecondaryBackgroundColor",
      hexToRgb(loginSecondaryBackgroundColor)
    );
    setCssVariable("--listPrimaryBackgroundColor", hexToRgb(listPrimaryBackgroundColor));
    setCssVariable("--listSecondaryBackgroundColor", hexToRgb(listSecondaryBackgroundColor));
    setCssVariable("--listBorderColor", hexToRgb(listBorderColor));
    setCssVariable("--listHeaderFontColor", hexToRgb(listHeaderFontColor));
    setCssVariable(
      "--listFirstColumnFontColor",
      hexToRgb(listFirstColumnFontColor)
    );
    setCssVariable("--listFontColor", hexToRgb(listFontColor));
    setCssVariable(
      "--listHeaderSortIconFontColor",
      hexToRgb(listHeaderSortIconFontColor)
    );

    setCssVariable("--loginButtonFontColor", hexToRgb(loginButtonFontColor));
    setCssVariable("--loginFontColor", hexToRgb(loginFontColor));
    setCssVariable("--loginButtonBgColor", hexToRgb(loginButtonBgColor));
  }, [colorsArray]);

  const getLogosList = (orgId: string) => {
    service
      .getOrgLogos(orgId)
      .then((res: any) => {
        setLogosList(res.data);
        setDynamicFavIcon(res.data.find((item: any) => item.iconkey === "favIcon").logopath)
        if (res.data.length > 0) {
          // console.log(JSON.parse(res.data[0].logo_path).filePath);
        }
      })
      .catch((err) => {
        catchError(err, false);
      });
  };

  const router = createBrowserRouter([
    {
      path: RoutesEnum.APICALLBACK,
      element: <ApiCallback />,
    },
    {
      path: `${RoutesEnum.SESSIONTIMEOUTPAGE}/:orgId`,
      element: <SessionTimeOutPage LogoData={logosList || []} />,
    },
    {
      path: `${RoutesEnum.FORGOTUSERNAME}/:orgId`,
      element: <Forgotusername LogoData={logosList || []} />,
    },
    {
      path: `${RoutesEnum.FORGOTPASSWORD}/:orgId`,
      element: <Forgotpassword LogoData={logosList || []} orgId={organizationId} />,
    },
    {
      path: `${RoutesEnum.RESETPASSWORD}/:id/:organizationId`,
      element: <Resetpassword organizationId={organizationId} />,
    },
    {
      path: RoutesEnum.ERROR,
      element: <FallBackUI />,
    },
    {
      path: RoutesEnum.UNAUTHORIZED,
      element: <AccessDenied />,
    },

    {
      path: RoutesEnum.ALL,
      element: <ProtectedRoute />,
      children: [
        {
          path: RoutesEnum.DEFAULT,
          element: <LandingPage LogoData={logosList || []} />,
          children: [{ path: RoutesEnum.LANDING }],
        },
        {
          path: RoutesEnum.ALL,
          element: (
            <LayoutPage LogoData={logosList || []} MenuItemsData={menuItems} />
          ),
          children: [
            {
              path: RoutesEnum.TRACKER,
              element: <TrackerPage />,
              children: [
                { path: TrackersEnum.PROSPECTING },
                { path: `${TrackersEnum.APPLICATIONS}/:orgProductId` },
                { path: `${TrackersEnum.OPPORTUNITIES}/:orgProductId` },
                { path: `${TrackersEnum.UNDERWRITING}/:orgProductId` },
                { path: TrackersEnum.RELATIONSHIPS },
              ],
            },
            {
              path: `${RoutesEnum.TRACKER_DETAILSPAGE}/:trackerName/:clientId/:clientProductsId?`,
              element: <ProspectingTrackerDetailsPage />,
            },
            {
              path: `${RoutesEnum.MESSAGE_CENTER}/:threadId?`,
              element: <MessageCenterFC />,
            },

            {
              path: RoutesEnum.CASETRACKER,
              element: <CaseTrackerPage />,
            },
            {
              path: RoutesEnum.CASETRACKER,
              element: <CaseDetailsPage />,
              children: [{ path: `details/:id` }],
            },
            {
              path: `${RoutesEnum.CLIENT_QUESTIONARIE}/:screenType/:clientId/:clientProductId`,
              element: <ClientPortalDashboard />
            },
            {
              path: `${RoutesEnum.CLIENT_QUESTIONARIE}/subCategories/:screenType/:categoryId/:clientProductId`,
              element: <ClientPortalCategoriesDetails />
            },
            {
              path: `${RoutesEnum.CLIENT_QUESTIONARIE}/questionarie/:screenType/:clientProductId/:categoryId/:subCategoryId`,
              element: <ClientPortalQuestionarie />
            },
            {
              path: `${RoutesEnum.COMPLIANCE_VIEW}/managmentReview/:clientProductId`,
              element: <MangementReviewDashboard />
            },
            {
              path: `${RoutesEnum.COMPLIANCE_VIEW}/riskSettings/:clientProductId`,
              element: <RiskSettingsDashboard />
            },
            {
              path: `${RoutesEnum.COMPLIANCE_VIEW}/merchantWelcome/:clientProductId`,
              element: <RiskSettingsDashboard />
            },
            {
              path: `${RoutesEnum.COMPLIANCE_VIEW}/getSummaryReport/:clientId/:clientProductId`,
              element: <ReviewSummaryReportPage />

            },
            {
              path: `${RoutesEnum.CLIENT_QUESTIONARIE}/:screenType/:clientId/:clientProductId`,
              element: <ReviewSummaryReportPage />
            },
            {
              path: `${RoutesEnum.PRICING_SHEET}/:clientId/:clientProductId`,
              element: <ViewSchedule />
            },

            {
              path: RoutesEnum.SETTINGS,
              element: <Settings />,
              children: [{ path: RoutesEnum.SETTINGS }],
            },

            {
              path: RoutesEnum.DASHBOARD,
              element: <DashboardPage />,
              children: [{ path: RoutesEnum.DASHBOARD }],
            },

            {
              path: `${RoutesEnum.QUESTIONNAIRE}/:type/:clientId/:clientProductsId`,
              element: <QuestionnariePage />,
            },
          ],
        },
      ],
    },

    // // Todo: Remove this if docu sign init redirect is not required
    // {
    //   path: `${RoutesEnum.DOCU_SIGN_INIT}/:clientId/:clientProductsId`,
    //   element: <DocuSignPage />,
    // },
    {
      path: `${RoutesEnum.DOCU_SIGN_REDIRECT}/:event?/:envelopeId?/:clientId?/:signingOption?`,
      element: <DocuSignPage />,
    },
  ]);


  return (
    <ErrorBoundary fallbackRender={fallbackRender}>
      <div className="App">
        <BankUserContext.Provider
          value={{
            bankRolesData: bankRolesData,
            bankuserDetails: bankUserDetails,
            updateClientDetails: updatedClientDetails,
            clientId: clientId,
            updateClientId: updateClientId,
            complianceDashboardPage: compliancepageRefresh,
            updateComplainceDashboardPage: updateComplainceDashboardPage,
            orgProductsList: orgProductsList,
            updateOrgProductsList: setOrgProductsList,
            selectedProduct: selectedProduct,
            setSelectedProduct: setSelectedProduct,
          }}
        >
          <Helmet>
            <meta charSet="utf-8" />
            <title>{menuItems?.tabName ? menuItems?.tabName : "nFiniti.AI Portal"}</title>
            <link rel="icon" href={dynamicFavIcon} />
          </Helmet>
          <RouterProvider router={router} />
          <SessionTimeout />
          <ToastContainer autoClose={1500} />
          {bankRolesData && <RoleAuthorizationCC />}
        </BankUserContext.Provider>
      </div>
    </ErrorBoundary>
  );
}

export default App;
